import { PoisBountySlice } from "./types";

export const initialState: PoisBountySlice = {
	variant: "intro",
	rewardCollected: undefined,
	allRewardsCollected: false,
	data: undefined,
	trackers: undefined,
	cycleTrackers: undefined,
	tracker: undefined,
	lp: 0,
	eventActive: false,
	eventEnded: false,
	rewards: [],
	sawUncollectedRewardsPopUp: false,
	rewardToClaim: undefined,
	isTagActive: false,
	canContribute: false,
	clubName: undefined,
	inactiveTrackers: undefined,
	hasSeenClaimedPopup: false
};
